import { helpers } from '@vuelidate/validators';

// SUP-411 — vuelidate 0.7's `numeric` is `regex('numeric', /^[0-9]*$/)` (digits only, empty
// allowed — presence is a separate `required` rule). @vuelidate/validators 2's own `numeric`
// (`regex(/^\d*(\.\d+)?$/)`) accepts a trailing fractional part, e.g. `1234.567`, which 0.7's
// `numeric` rejects. AC-2 requires the same acceptance set as today, so this is a verbatim port
// of 0.7's regex, following the `email.js` override shape. Parity proof:
// `validators-parity.spec.js`'s `P-numeric` row.
export default {
  $validator: helpers.regex(/^[0-9]*$/),
  $message: 'Value must be numeric',
  $params: { type: 'numeric' },
};
